import { render } from "./Header.vue?vue&type=template&id=67c98360&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=67c98360&lang=scss&scoped=true"
import "./Header.vue?vue&type=style&index=1&id=67c98360&lang=css"

import exportComponent from "/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c98360"]])

export default __exports__